import React from 'react';
import { useSelector } from 'react-redux';
import { Content, FlexboxGrid, Col, Grid, Row } from 'rsuite';
import PortalHeader from '../../components/layout/PortalHeader';
import { selectConfigSettings } from '../../store/slices/config/configSelectors';
import { selectCurrentFlow } from '../../store/slices/flow/flowSelectors';

/**
 * This components is meant to be a generic message to display to the user no matter if the payment
 * is successful or has errored. This is required in some payment providers such as
 * xpressbillpay where there's no wayh to handle errors and redirect the user to a more
 * appropiate error page.
 */
const PaymentCompleted = () => {
  const settings = useSelector(selectConfigSettings);
  const currentFlow = useSelector(selectCurrentFlow);
  const place = settings.placeDisplayName;

  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader flow={currentFlow} />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={24}>
        <Content>
          <Grid
            className="mt-24 ml-24 mr-24"
            fluid
          >
            <Row role="presentation">
              <Col
                role="presentation"
                className="content-section"
                xs={24}
              >
                <p>Thank you for your application.</p>
                <p>If you have cancelled your payment during the payment process, you will need to restart the application process from the beginning.</p>
                <p>
                  If you have completed your payment, you will receive a receipt by email once your payment has been received. Thank you for submitting your application payment. Your actions today allow short-term rentals to be an attractive choice for {place}{' '}
                  visitors, while maintaining the residential character of our neighbourhoods.
                </p>
              </Col>
            </Row>
          </Grid>
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default PaymentCompleted;
